// extracted by mini-css-extract-plugin
var _1 = "FmPNN";
export { _1 as "userSelectNone" }
